import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { STATE_MANAGEMENT_CONFIGURATION_TOKEN, states } from './tokens';

@NgModule({
  imports: [CommonModule]
})
export class CommonUtilStateManagementModule {
  static forRoot(stateName: string): ModuleWithProviders {
    return {
      ngModule: CommonUtilStateManagementModule,
      providers: [
        {
          provide: STATE_MANAGEMENT_CONFIGURATION_TOKEN,
          useValue: stateName
        }
      ]
    };
  }
}
